import React from 'react';
import styled from 'styled-components';

import useInView from '../hooks/usePercentInView';

const AnimatedLineWrapper = styled.div`
    height: ${({ sectionHeight }) => sectionHeight || 200}px;
    div {
        width: 1px;
        background-color: ${({ color }) => color || `#fff`};
        margin: 0 auto;
        height: 100%
    }
`;
 
const AnimatedLine = ({ lineRef, sectionHeight, color, className}) => {
    const currentPercentage = useInView(lineRef)
    const clipPercentage = Math.floor((100 - currentPercentage) - 40);

    return (
        <AnimatedLineWrapper 
            noTopPadding
            noBottomPadding
            sectionHeight={sectionHeight}
            color={color}
            className={`animated-line__wrapper ${className}`}
        >
        <div style={{ clipPath: `inset(0 0 ${clipPercentage}% 0)` }} ref={lineRef} />
    </AnimatedLineWrapper>
    )
}
 
export default AnimatedLine